import React from "react";
import styled, { css } from "styled-components";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Button from "@mui/material/Button";

const Modal = styled.div`
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;

  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const WrapperModal = styled.div`
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  width: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 35px 30px;
  width: 85%;
  max-width: 444px;
  animation: showModal 0.5s;
  @keyframes showModal {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`;
const DivTextProp = styled.div`
  width: 100%;
  white-space: pre-line;
  font-size: 1rem;

  ${({ isIcon }) => isIcon ?
    css`
      margin-left: 20px;
      text-align: left;
    `
    : css`
      text-align: center;
    `
  }
`;

const DivFlexTextProp = styled.div`
  display: flex;
  width: 100%;
`;

const DivFlexButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 40px;
  .Button-Confrim {
    color: #ffffff;
    width: auto;
    background-color: #e04132;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    padding: 6px 22px;
    text-transform: uppercase;
  }
  .Button-Confrim:focus {
    background-color: #e04132;
  }
  .Button-Confrim:hover {
    background-color: #e04132;
  }

  .Button-Cancel {
    color: #e04132;
    width: auto;
    background-color: transparent;
    border: 1px solid #e04132;
    border-radius: 16px;
    padding: 6px 22px;
    margin-right: 15px;
    text-transform: uppercase;
  }
  .Button-Cancel:focus {
    background-color: transparent;
  }
  .Button-Cancel:hover {
    background-color: transparent;
  }
`;

function ModalConfirm({
  title,
  textCancel,
  textConfirm,
  callBack,
  icon,
  style,
}) {
  return (
    <Modal style={style}>
      <WrapperModal>
        <DivFlexTextProp>
          {icon === "delete" && (
            <DeleteOutlineOutlinedIcon sx={{ color: "rgba(0, 0, 0, 0.54)" }} />
          )}
          <DivTextProp isIcon={icon === "delete" ? true : false}>{title}</DivTextProp>
        </DivFlexTextProp>

        <DivFlexButton>
          <Button className="Button-Cancel" onClick={() => callBack(false)}>
            {textCancel ? textCancel : "Cancel"}
          </Button>
          <Button className="Button-Confrim" onClick={() => callBack(true)}>
            {textConfirm ? textConfirm : "Delete"}
          </Button>
        </DivFlexButton>
      </WrapperModal>
    </Modal>
  );
}

export default ModalConfirm;
